import env from '@/env';
import createAuthorizedApiClient, { AuthTokenType } from '../authorized-api-client';

const identityApiClient = createAuthorizedApiClient(
  env.api.baseUrl.identityService,
  AuthTokenType.AccessToken,
);

export default identityApiClient;
